import { useSearchParams } from 'react-router-dom'

export function GraciasPage() {
  const [searchParams] = useSearchParams()
  const tipo = searchParams.get('tipo') // 'encuesta' | null
  const redirect = searchParams.get('redirect')

  const esEncuesta = tipo === 'encuesta'
  const titulo = esEncuesta ? '¡Formulario Completado!' : '¡Solicitud Enviada!'
  const descripcion = esEncuesta
    ? 'Tus respuestas han sido recibidas exitosamente.'
    : 'Tu solicitud ha sido recibida exitosamente.'

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-green-50 flex items-center justify-center py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-2xl w-full text-center">
        {/* Logo */}
        <div className="mb-8">
          <img
            src="/logo-tonal-negro.png"
            alt="Tonal"
            className="mx-auto h-12 w-auto"
            onError={(e) => { e.currentTarget.style.display = 'none' }}
          />
        </div>

        {/* Checkmark Animation */}
        <div className="mb-8">
          <div className="mx-auto w-32 h-32 bg-green-100 rounded-full flex items-center justify-center">
            <svg className="w-20 h-20" viewBox="0 0 52 52">
              <circle
                cx="26" cy="26" r="25"
                fill="none" stroke="#10b981" strokeWidth="2"
                style={{
                  strokeDasharray: 166,
                  strokeDashoffset: 166,
                  animation: 'checkmark-circle 1s ease-in-out 0.5s forwards',
                }}
              />
              <path
                fill="none" stroke="#10b981" strokeWidth="3"
                strokeLinecap="round" strokeLinejoin="round"
                d="m16 26 6 6 14-14"
                style={{
                  strokeDasharray: 48,
                  strokeDashoffset: 48,
                  animation: 'checkmark-check 0.5s ease-in-out 1.2s forwards',
                }}
              />
            </svg>
          </div>
        </div>

        {/* Success Message */}
        <div className="mb-8" style={{ opacity: 0, animation: 'fade-in 0.8s ease-out 1s forwards' }}>
          <h1 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">{titulo}</h1>
          <p className="text-lg text-gray-600">{descripcion}</p>
        </div>

        {/* Information Card */}
        <div style={{ opacity: 0, animation: 'fade-in 0.8s ease-out 1.5s forwards' }}>
          {!esEncuesta && (
            <div className="bg-white shadow-lg rounded-lg p-8 mb-8 border border-gray-300">
              <div className="space-y-6">
                <div className="flex items-center justify-center space-x-2 text-blue-600">
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  <h2 className="text-xl font-semibold">¿Qué sigue ahora?</h2>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-sm">
                  <div className="text-center">
                    <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-3">
                      <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                      </svg>
                    </div>
                    <h3 className="font-medium text-gray-900 mb-2">1. Revisión</h3>
                    <p className="text-gray-600">Nuestro equipo revisará tu solicitud en las próximas 24-48 horas.</p>
                  </div>

                  <div className="text-center">
                    <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-3">
                      <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                      </svg>
                    </div>
                    <h3 className="font-medium text-gray-900 mb-2">2. Contacto</h3>
                    <p className="text-gray-600">Te contactaremos por llamada telefónica con los detalles del envío.</p>
                  </div>

                  <div className="text-center">
                    <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-3">
                      <svg className="w-6 h-6 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
                      </svg>
                    </div>
                    <h3 className="font-medium text-gray-900 mb-2">3. Envío</h3>
                    <p className="text-gray-600">Las muestras médicas serán enviadas a tu dirección registrada.</p>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Contact Information */}
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-6 text-left">
            <div className="flex items-start space-x-3">
              <div className="flex-shrink-0">
                <svg className="w-6 h-6 text-blue-600 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <div>
                <h3 className="font-medium text-blue-900 mb-2">¿Necesitas ayuda?</h3>
                <p className="text-blue-800 text-sm mb-2">
                  Si tienes alguna pregunta no dudes en contactarnos:
                </p>
                <div className="text-sm text-blue-800">
                  <p><strong>Email:</strong> a.villota@tonalstrategies.com</p>
                  <p><strong>Teléfono:</strong> +593 98 194 1812</p>
                </div>
              </div>
            </div>
          </div>

          {/* Social Media */}
          <div className="mt-8 text-center">
            <p className="text-sm text-gray-500 mb-4">
              Síguenos en nuestras redes sociales para más información
            </p>
            <div className="flex justify-center">
              <a
                href="https://linkedin.com/company/tonalstrategies"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-blue-600 transition-colors duration-200"
              >
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                </svg>
              </a>
            </div>
          </div>

          {redirect && (
            <div className="mt-6 text-center">
              <a
                href={redirect}
                className="inline-flex items-center px-6 py-3 text-base font-semibold text-white bg-blue-700 hover:bg-blue-800 rounded-lg shadow-lg transition-all duration-200"
              >
                Continuar
              </a>
            </div>
          )}

          {/* Footer */}
          <div className="mt-8 text-center">
            <p className="text-sm text-gray-500">
              Powered by <strong>Tonal Strategies</strong>
            </p>
          </div>
        </div>

        {/* CSS animations */}
        <style>{`
          @keyframes checkmark-circle {
            0% { stroke-dashoffset: 166; }
            100% { stroke-dashoffset: 0; }
          }
          @keyframes checkmark-check {
            0% { stroke-dashoffset: 48; }
            100% { stroke-dashoffset: 0; }
          }
          @keyframes fade-in {
            0% { opacity: 0; transform: translateY(20px); }
            100% { opacity: 1; transform: translateY(0); }
          }
        `}</style>
      </div>
    </div>
  )
}
